import(/* webpackMode: "eager" */ "/app/node_modules/@style-port/roov-ui-components-react/dist/style.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-navigation-guard/dist/components/NavigationGuardProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-navigation-guard/dist/components/NavigationGuardProviderContext.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Rubik\",\"arguments\":[{\"weight\":[\"300\",\"500\"],\"subsets\":[\"latin\"],\"variable\":\"--font-rubik\"}],\"variableName\":\"RubikFont\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AutoHideInitialGlobalLoading"] */ "/app/src/components/organisms/others/AutoHideInitialGlobalLoading.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/others/globalLoadingModal.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/app/src/libs/apollo-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/GaRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/SnackbarRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/styledComponentsRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/UIAssetRegistry.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.scss");
